import { useEffect, useState } from "react"
import { useLocation } from "react-router-dom"
import { Box, CircularProgress, Typography } from "@mui/material"
import Cookies from "js-cookie"
import { getAllTenantDetails } from "../api/tenant"
import MainLayout from "../layouts/MainLayout"
import GenericTenantPage from "../pages/GenericTenant/GenericTenantPage"
import CustomPage from "../pages/Custom/CustomPage"
import GenericErrorPage from "../components/shared/GenericErrorPage"

export default function TenantRouter() {
  const location = useLocation()
  const params = new URLSearchParams(location.search)
  const tenantSlug = params.get("tenant")

  const [tenant, setTenant] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (!tenantSlug) return
    Cookies.set("tenant", tenantSlug, { expires: 7 })
    sessionStorage.setItem("tenant", tenantSlug)
  }, [tenantSlug])

  useEffect(() => {
    if (!tenantSlug) return

    const fetchTenant = async () => {
      try {
        setLoading(true)
        const res = await getAllTenantDetails()
        const allTenants = res?.data || []

        const foundTenant = allTenants.find(
          (t) => t.slug?.toLowerCase() === tenantSlug.toLowerCase(),
        )

        setTenant(foundTenant || null)
      } catch (err) {
        console.error("Error fetching tenants:", err)
      } finally {
        setLoading(false)
      }
    }

    fetchTenant()
  }, [tenantSlug])

  if (loading) {
    return (
      <MainLayout>
        <Box
          sx={{
            minHeight: "60vh",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: 2,
          }}
        >
          <CircularProgress size={32} />
          <Typography variant="body1" color="text.subcaption">
            Loading tenant...
          </Typography>
        </Box>
      </MainLayout>
    )
  }
  if (!tenant) return <GenericErrorPage />

  if (tenant.is_custom && tenant.custom_name) {
    return <CustomPage custom_name={tenant.custom_name} />
  }

  return <GenericTenantPage tenant={tenant} />
}
